var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "storeReport" }, [
    _c("iframe", { attrs: { id: "storeFrame", src: _vm.src } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }